export default "__VITE_ASSET__DgXEYyZn__"